document.addEventListener("DOMContentLoaded", function () {
  const glideConfig = {
    type: "carousel",
    autoplay: 3000,
    hoverpause: true,
    animationDuration: 800,
    gap: 10,
  };

  //================= Homepage Banner Slider =====================
  const bannerSlider = document.querySelector(".autify-banner-slider");

  if (bannerSlider) {
    const slides = bannerSlider.querySelectorAll(".glide__slide");
    const bullets = bannerSlider.querySelector(".glide__bullets");

    if (slides.length > 1) {
      new Glide(bannerSlider, { ...glideConfig, perView: 1 }).mount();
    } else {
      // Prevent slider initialization and hide bullets
      if (bullets) {
        bullets.style.display = "none";
      }

      // Optional: add static class to handle layout
      bannerSlider.classList.add("glide--static");
    }
  }

  //==================== Banner Click Function ==================
  document.querySelectorAll(".autify-slide__background").forEach((slide) => {
    slide.addEventListener("click", function (event) {
      if (event.target.closest(".autify-button")) return;
      const link = this.getAttribute("data-link");
      if (link && link !== "#") {
        window.location.href = link;
      }
    });
  });

  //==================== Product Carousel =========================
  const productCarousel = document.querySelectorAll(".autify-product-carousel");
  productCarousel.forEach((carousel) => {
    if (carousel) {
      new Glide(carousel, {
        ...glideConfig,
        perView: 4,
        breakpoints: {
          1024: { perView: 3 },
          768: { perView: 1 }
        }
      }).mount();
    }
  });

  //==================== Collection Image Carousel =================
    const collectionCarousel = document.querySelectorAll(".autify-collectionh-carousel");
  
    collectionCarousel.forEach((carousel) => {
      if (!carousel) return;
  
      const slidesContainer = carousel.querySelector('.glide__slides');
      const originalSlides = Array.from(slidesContainer.querySelectorAll('.glide__slide'));
      const originalSlideCount = originalSlides.length;
  
      const perView = 5;
      const hasEnoughSlides = originalSlideCount > perView;
  
      // Clone slides only if needed for looping
      if (hasEnoughSlides) {
        const cloneCount = perView;
  
        // Prepend clones from the end
        for (let i = originalSlideCount - cloneCount; i < originalSlideCount; i++) {
          const clone = originalSlides[i].cloneNode(true);
          clone.classList.add('glide__slide--clone');
          slidesContainer.insertBefore(clone, slidesContainer.firstChild);
        }
  
        // Append clones from the beginning
        for (let i = 0; i < cloneCount; i++) {
          const clone = originalSlides[i].cloneNode(true);
          clone.classList.add('glide__slide--clone');
          slidesContainer.appendChild(clone);
        }
      }
  
      // Add counter UI
      const counterElement = document.createElement('div');
      counterElement.className = 'glide-counter';
      counterElement.innerHTML = '<span class="current-slide">1</span>/<span class="total-slides"></span>';
      carousel.appendChild(counterElement);
  
      const currentSlideEl = counterElement.querySelector('.current-slide');
      const totalSlidesEl = counterElement.querySelector('.total-slides');
  
      const glide = new Glide(carousel, {
        type: hasEnoughSlides ? 'carousel' : 'slider',
        startAt: hasEnoughSlides ? perView : 0,
        perView: hasEnoughSlides ? perView : originalSlideCount,
        rewind: false,
        gap: 20,
        animationDuration: 800,
        breakpoints: {} // disable breakpoints for now
      });
  
      glide.on('mount.after', () => {
        totalSlidesEl.textContent = originalSlideCount;
        currentSlideEl.textContent = 1;
      });
  
      glide.on('run.after', () => {
        let realIndex = glide.index;
        if (hasEnoughSlides) {
          realIndex = (glide.index - perView + originalSlideCount) % originalSlideCount;
          if (realIndex < 0) realIndex += originalSlideCount;
        }
        currentSlideEl.textContent = realIndex + 1;
      });
  
      glide.mount();
  
      // Hide controls if not enough slides
      if (!hasEnoughSlides) {
        const navs = carousel.querySelectorAll('[data-glide-el="controls"], [data-glide-el="controls[nav]"]');
        navs.forEach(el => el.style.display = 'none');
      }
    });

  //==================== Product Recommendations Carousel =========================
  const productRecommendations = document.querySelector("product-recommendations");

  // Use MutationObserver to detect when content is added inside product-recommendations
  if (productRecommendations) {
    const observer = new MutationObserver(function (mutationsList, observer) {
      const relatedProductsSlider = document.querySelector(".autify-product-carousel-v2");
      if (relatedProductsSlider) {
        console.log('showing related products')
        // Initialize Glide once the product recommendations content is loaded
        new Glide(relatedProductsSlider, {
          ...glideConfig,
          perView: 5,
          breakpoints: {
            1024: { perView: 4, gap: 8 },
            768: { perView: 1, gap: 5 }
          }
        }).mount();

        // Disconnect the observer once the Glide instance is mounted
        observer.disconnect();
      }
    });

    // Start observing the <product-recommendations> element for changes
    observer.observe(productRecommendations, { childList: true, subtree: true });
  }

  //==================== Personalized Engraving Filter Switching =========================
  const filterSwitch = document.getElementById("personalized-filter");

  if (filterSwitch) {
  const collectionUrl = `/${window.location.pathname.split("/").slice(1, 3).join("/")}`;
  const slider = filterSwitch.nextElementSibling; // This gets the .slider span

  if (window.location.pathname.includes("/engraving")) {
    filterSwitch.checked = true;
    if (slider) slider.classList.add("active-slider"); // Add class on page load if needed
  }

  filterSwitch.addEventListener("change", function () {
    if (slider) {
      slider.classList.toggle("active-slider", this.checked); // Adds/removes class based on checked state
    }

    window.location.href = this.checked ? `${collectionUrl}/engraving` : collectionUrl;
  });
  }

  //==================== Layout Switching =========================
  const productGrid = document.querySelector(".autify-listing-collection .collection ul#product-grid");
  const threeColIcon = document.getElementById("three-col-icon");
  const fourColIcon = document.getElementById("four-col-icon");

  if (productGrid && threeColIcon && fourColIcon) {
    const updateGrid = (selectedIcon) => {
      productGrid.classList.toggle("grid--3-col-desktop", selectedIcon === "three");
      productGrid.classList.toggle("grid--4-col-desktop", selectedIcon === "four");
      threeColIcon.classList.toggle("active", selectedIcon === "three");
      fourColIcon.classList.toggle("active", selectedIcon === "four");
    };
    
    updateGrid("four");

    threeColIcon.addEventListener("click", () => updateGrid("three"));
    fourColIcon.addEventListener("click", () => updateGrid("four"));
  }


  //==================== Mobile Layout Switching =========================
  const m_productGrid = document.querySelector(".autify-listing-collection .collection ul#product-grid");
  const oneColIcon = document.getElementById("two-col-icon");
  const twoColIcon = document.getElementById("one-col-icon");

  if (m_productGrid && oneColIcon && twoColIcon) {
    const updateGrid = (selectedIcon) => {
      m_productGrid.classList.toggle("grid--2-col-tablet-down", selectedIcon === "three");
      m_productGrid.classList.toggle("grid--1-col-tablet-down", selectedIcon === "four");
      oneColIcon.classList.toggle("active", selectedIcon === "three");
      twoColIcon.classList.toggle("active", selectedIcon === "four");
    };
    
    updateGrid("four");

    oneColIcon.addEventListener("click", () => updateGrid("three"));
    twoColIcon.addEventListener("click", () => updateGrid("four"));
  }

  //==================== Accordion ===========================
  const accordions = document.querySelectorAll(".accordion-title");
  const accordionItems = document.querySelectorAll(".accordion-item");

  if (accordionItems.length > 0) {
    const firstItem = accordionItems[0];
    const firstContent = firstItem.querySelector(".accordion-content");

    if (firstContent) {
      firstItem.classList.add("active");
      firstContent.style.height = firstContent.scrollHeight + "px";
      setTimeout(() => firstContent.style.height = "auto", 300);
    }

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", function () {
        const parent = this.parentElement;
        const content = parent.querySelector(".accordion-content");

        if (parent.classList.contains("active")) {
          content.style.height = content.scrollHeight + "px";
          setTimeout(() => content.style.height = "0px", 10);
          parent.classList.remove("active");
        } else {
          accordionItems.forEach((item) => {
            const otherContent = item.querySelector(".accordion-content");
            if (item.classList.contains("active")) {
              otherContent.style.height = otherContent.scrollHeight + "px";
              setTimeout(() => otherContent.style.height = "0px", 10);
              item.classList.remove("active");
            }
          });
          content.style.height = content.scrollHeight + "px";
          setTimeout(() => content.style.height = "auto", 300);
          parent.classList.add("active");
        }
      });
    });
  }


//Back to Top - Button
const backToTopBtn = document.getElementById('back-to-top-btn');   
  // Show button when user scrolls down 300px from the top
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 300) {
      backToTopBtn.classList.add('visible');
    } else {
      backToTopBtn.classList.remove('visible');
    }
  });
  
  // Smooth scroll to top when button is clicked
  backToTopBtn.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });


});

//************** Custom Carousel Script */
// **************** Carousel Script ********************
(function () {
  const carousels = document.querySelectorAll('[data-carousel]');
  if (!carousels.length) return;

  carousels.forEach(wrapper => {
    const track = wrapper.querySelector('[data-track]');
    const nextBtn = wrapper.querySelector('[data-next]');
    const prevBtn = wrapper.querySelector('[data-prev]');

    if (!track || !nextBtn || !prevBtn) return;

    const items = track.querySelectorAll('.autify-category-carousel-item');
    const totalItems = items.length;
    let currentIndex = 0;

    // function getItemsPerView() {
    //   return window.innerWidth <= 768 ? 1.35 : 4;
    // }

    function getItemsPerView() {
        if (window.innerWidth < 768) {
            return 1;
        } else if (window.innerWidth >= 768 && window.innerWidth <= 950) {
            return 2;
        } else {
            return 4;
        }
    }

    const isDesktop = window.innerWidth > 768;

    // Hide arrows ONLY on desktop if total items <= 4
    if (isDesktop && totalItems <= 5) {
      nextBtn.style.display = 'none';
      prevBtn.style.display = 'none';
      return;
    }

    function updateCarousel() {
      const itemsPerView = getItemsPerView();
      const itemWidth = 100 / itemsPerView;
      const translateX = -(currentIndex * itemWidth);
      track.style.transform = `translateX(${translateX}%)`;

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= totalItems - itemsPerView;
    }

    nextBtn.addEventListener('click', () => {
      const itemsPerView = getItemsPerView();
      const maxIndex = totalItems - itemsPerView;
      if (currentIndex < maxIndex) {
        const advance = Math.min(itemsPerView - 2, maxIndex - currentIndex);
        currentIndex += Math.max(1, advance);
        updateCarousel();
      }
    });

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        const itemsPerView = getItemsPerView();
        const goBack = Math.min(itemsPerView - 2, currentIndex);
        currentIndex -= Math.max(1, goBack);
        updateCarousel();
      }
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const itemsPerView = getItemsPerView();
        const maxIndex = totalItems - itemsPerView;

        // Re-check arrow visibility on resize (if switching between mobile/desktop)
        if (window.innerWidth > 768 && totalItems <= 5) {
          nextBtn.style.display = 'none';
          prevBtn.style.display = 'none';
        } else {
          nextBtn.style.display = '';
          prevBtn.style.display = '';
        }

        if (currentIndex > maxIndex) {
          currentIndex = Math.max(0, maxIndex);
        }
        updateCarousel();
      }, 250);
    });

    // Touch + Mouse Drag
    let isDragging = false;
    let startX = 0;
    let endX = 0;

    function startDrag(x) {
      isDragging = true;
      startX = x;
    }

    function moveDrag(x) {
      if (!isDragging) return;
      endX = x;
    }

    function endDrag() {
      if (!isDragging) return;

      const diffX = endX - startX;
      const threshold = 50;

      if (diffX > threshold && currentIndex > 0) {
        currentIndex -= 1;
      } else if (diffX < -threshold && currentIndex < totalItems - getItemsPerView()) {
        currentIndex += 1;
      }

      updateCarousel();
      isDragging = false;
    }

    track.addEventListener('touchstart', e => startDrag(e.touches[0].clientX));
    track.addEventListener('touchmove', e => moveDrag(e.touches[0].clientX));
    track.addEventListener('touchend', endDrag);

    track.addEventListener('mousedown', e => startDrag(e.clientX));
    track.addEventListener('mousemove', e => moveDrag(e.clientX));
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // Prevent image dragging ghost effect
    items.forEach(item => {
      item.addEventListener('dragstart', e => e.preventDefault());
    });

    // Init this carousel
    updateCarousel();
  });
})();